import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { Tooltip } from '@mantine/core';

import { NumberInput } from 'ui-components/components/number-input';
import { convertUnitPositionToAdornmentPosition, UnitAdornment } from 'ui-components/components/number-input/unit-adornment';

import { DimensionTypePropType } from '../../../../enums/dimension-type';
import { UnitPosition, UnitPositionPropType } from '../../../../enums/units/unit-position';
import { DimensionUnitLabel } from './unit-label';

import style from 'ui-components/components/dimension-input/dimension-number-input/style.module.css';

export const DimensionNumberInput = ({
  dimensionType,
  value = null,
  className = null,
  onFocus,
  onArrowButtonPress = null,
  onBlur,
  disabled = false,
  disabledTooltipLabel = null,
  shrinkable = false,
  testId = '',
  onChange,
  unitPosition = UnitPosition.OutsideEnd,
  labelId,
  parentLabelId,
}) => {
  const adornmentPosition = convertUnitPositionToAdornmentPosition(unitPosition);
  const unitLabel = <DimensionUnitLabel dimensionType={dimensionType} />;
  const inputLabel = parentLabelId ? `${parentLabelId} ${labelId}` : labelId;

  const changeDimensionValue = useCallback(
    (newValue) => {
      onChange(dimensionType, newValue);
    },
    [dimensionType, onChange],
  );

  const onBlurNumberInput = useCallback(() => {
    onBlur(dimensionType);
  }, [onBlur, dimensionType]);

  return (
    <Tooltip disabled={!disabled || !disabledTooltipLabel} label={disabledTooltipLabel}>
      <div className={style.dimension} data-input-type={dimensionType}>
        <NumberInput
          adornment={<UnitAdornment id={labelId} unitLabel={unitLabel} unitPosition={unitPosition} />}
          adornmentPosition={adornmentPosition}
          className={className}
          disabled={disabled}
          label={`${dimensionType} input`}
          labelId={inputLabel}
          min={0}
          onArrowButtonPress={onArrowButtonPress}
          onBlur={onBlurNumberInput}
          onChange={changeDimensionValue}
          onFocus={onFocus}
          shrinkable={shrinkable}
          testId={testId}
          value={value}
        />
        {unitPosition === UnitPosition.OutsideEnd && <label id={labelId}>{unitLabel}</label>}
      </div>
    </Tooltip>
  );
};

DimensionNumberInput.propTypes = {
  value: PropTypes.number,
  dimensionType: DimensionTypePropType.isRequired,
  onChange: PropTypes.func.isRequired,
  onArrowButtonPress: PropTypes.func,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledTooltipLabel: PropTypes.node,
  shrinkable: PropTypes.bool,
  testId: PropTypes.string,
  unitPosition: UnitPositionPropType,
  labelId: PropTypes.string,
  parentLabelId: PropTypes.string,
};
